/*
 * @Author: cn1994
 * @Date: 2023-09-15 18:03:36
 * @LastEditors: cn1994
 * @LastEditTime: 2024-03-03 15:31:17
 * @Description: file content
 */
const routes = [
  { // 微官网设置
    path: '/wechat/website',
    name: 'wechatWebsite',
    meta: {
      title: '微官网设置',
      volcengine: true,
    },
    component: () => import('../pages/iframe/index.vue'),
  },
  { // 费用中心
    path: '/cost/center',
    name: 'costCenter',
    meta: {
      title: '费用中心',
      hasBack: true,
      volcengine: true,
    },
    component: () => import('../pages/costCenter/index.vue'),
  },
  { // 增值服务
    path: '/service/center',
    name: 'serviceCenter',
    meta: {
      title: '增值服务',
      hasBack: true,
      volcengine: true,
    },
    component: () => import('../pages/services/index.vue'),
  },
]
export default routes